<template>
    <div class="list-item">
        <vs-list-item :class="{selected: item.checked == true, unselect: item.checked == false}">
            <vs-checkbox v-model="item.checked">
                <div class="title pl-4 font-bold text-2xl">{{item.title}}</div>
                <div class="content pl-4">{{item.content}}</div>
            </vs-checkbox>
        </vs-list-item>
    </div>
</template>

<script>
export default {
    name: 'list-item',
    props: {
        item: {
            type: Object,
            required: true
        }
    }

}
</script>

<style lang="scss">
    @import "@/assets/scss/vuexy/_variables";
    @import "@/assets/scss/custom/_variables";
    .list-item {
        .vs-list--item {
            border-radius: 4px;
            .vs-list--slot {
                margin-left: 0.45rem;
                width: 100%;
                transition: 0.2s ease;
                .title {
                    color: rgba($primary, 0.7);
                }

                .content {
                    opacity: 0.8;
                }
            }

            &:hover {
                background: rgba(0, 0, 0, 0.07);
                .vs-list--slot {
                    margin-left: 0.6rem;
                }
            }
        }

        .selected {
            position: relative;
            color: #fff;

            .title {
                color: #fff !important;
            }
            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                border-radius: 4px;
                background: linear-gradient(90deg, rgba($primary, 1), rgba($primary, 0.7));
                z-index: -1;
                animation: animate-selected 0.15s linear;
            }
            @keyframes animate-selected {
                0% {
                    width: 0%;
                }
                // 25% {
                //     width: 25%;
                // }
                // 50% {
                //     width: 50%;
                // }
                // 75% {
                //     width: 75%;
                // }
                100% {
                    width: 100%;
                }
            }
        }

        .unselect {
            position: relative;
            &::after {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                width: 0%;
                height: 100%;
                border-radius: 4px;
                background: linear-gradient(90deg, rgba($primary, 1), rgba($primary, 0.7));
                z-index: -1;
                animation: animate-unselect 0.15s linear;
            }
            @keyframes animate-unselect {
                0% {
                    width: 100%;
                }
                // 25% {
                //     width: 75%;
                // }
                // 50% {
                //     width: 50%;
                // }
                // 75% {
                //     width: 25%;
                // }
                100% {
                    width: 0%;
                }
            }
        }
    }
</style>
